import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import infoimage from "../../../../../assests/images/theinfo.webp";
import forbes from "../../../../../assests/images/forbes.png";
import nasdaq from "../../../../../assests/images/nasdaq.png";
import bloomburg from "../../../../../assests/images/bloomburg.png";
import cision from "../../../../../assests/images/cision.png";
import financial from "../../../../../assests/images/fintech.png";
import tracxn from "../../../../../assests/images/tracxn.png";
import { BsArrowRight } from "react-icons/bs";
gsap.registerPlugin(ScrollTrigger);

const articles = [
  {
    id: 1,
    source: "The Information",
    sourceColor: "#e8413e",
    src: infoimage,
    title: "Checking in on Crypto’s Most Promising Startups",
    date: "July 5, 2023",
    url: "#",
  },
  {
    id: 2,
    source: "Forbes",
    sourceColor: "#000000",
    src: forbes,
    title:
      "U.S. Government Owns Way More Bitcoin Than Any Other Country–So Why Aren’t They Selling It?",
    date: "June 16, 2023",
    url: "#",
  },
  {
    id: 3,
    source: "Nasdaq",
    sourceColor: "#0099cc",
    src: nasdaq,
    title:
      "Why Large-Scale Institutional Adoption of Blockchain Technology Is Coming",
    date: "April 26, 2023",
    url: "#",
  },
  {
    id: 4,
    source: "Bloomberg",
    sourceColor: "#000000",
    src: bloomburg,
    title: "Celsius Creditors Seek to Unmask 'Suspicious' FTX Crypto Trades",
    date: "April 26, 2023",
    url: "#",
  },
  {
    id: 5,
    source: "Vision",
    sourceColor: "#ff6600",
    src: cision,
    title: "Element Us Labs Raises $10M in Funding Led by ParaFi Capital",
    date: "February 6, 2023",
    url: "#",
  },
  {
    id: 6,
    source: "The Financial Times",
    sourceColor: "#c6007e",
    src: financial,
    title:
      "Global Crypto Exchange's 'Bank Level Security' Allegedly a Myth Following Unresolved Hacks",
    date: "February 1, 2023",
    url: "#",
  },
  {
    id: 7,
    source: "The Financial Times",
    sourceColor: "#c6007e",
    src: tracxn,
    title:
      "Element Us Labs Named Top Blockchain Infrastructure Startup by Tracxn",
    date: "January 24, 2023",
    url: "#",
  },
  {
    id: 8,
    source: "The Financial Times",
    sourceColor: "#c6007e",
    src: cision,
    title:
      "Element Us Labs Partners with CryptoArmor to Bring Enhanced Protection to Blockchain Businesses",
    date: "December 15,2022",
    url: "#",
  },
  {
    id: 9,
    source: "The Financial Times",
    sourceColor: "#c6007e",
    src: "https://cdn.prod.website-files.com/6362234779d349f407aa36d5/6388653976d96ed43867ff06_new-york-post.svg",
    title:
      "At least $300 million was looted from FTX, unclear if it will get paid back",
    date: "November 23,2022",
    url: "#",
  },
  {
    id: 10,
    source: "The Financial Times",
    sourceColor: "#c6007e",
    src: "https://cdn.prod.website-files.com/6362234779d349f407aa36d5/6388654082d2a957f811c20d_the-information.svg",
    title: "Bankruptcies Boost Analytics Startups—For Now; Sequoia’s Black Eye",
    date: "November 23,2022",
    url: "#",
  },
  {
    id: 11,
    source: "The Financial Times",
    sourceColor: "#c6007e",
    src: "https://cdn.prod.website-files.com/6362234779d349f407aa36d5/63886545ff628b36e71ec9e4_wired.svg",
    title: "Wired Magazine - Crypto Contagion Is Spreading, Fast",
    date: "November 25,2022",
    url: "#",
  },
  {
    id: 12,
    source: "The Financial Times",
    sourceColor: "#c6007e",
    src: "https://cdn.prod.website-files.com/6362234779d349f407aa36d5/638865498ac4bc5cd9dce585_coindesk.svg",
    title: "Hackers Just Stole Another $180K in Ether from Cryptopia Exchange",
    date: "January 30, 2019",
    url: "#",
  },
];

function ArticleRow({ article, rowRef }) {
  const btnRef = useRef(null);
  const arrowRef = useRef(null);
  const cloneRef = useRef(null);
  const enterTl = useRef(null);
  const leaveTl = useRef(null);

  useEffect(() => {
    const btn = btnRef.current;
    const arrow = arrowRef.current;
    const clone = cloneRef.current;
    const row = rowRef.current;

    gsap.set(clone, { x: -7, y: 7, opacity: 0 });

    enterTl.current = gsap
      .timeline({ paused: true })
      .to(
        btn,
        {
          backgroundColor: "#12132b",
          borderColor: "#12132b",
          duration: 0.22,
          ease: "power2.out",
        },
        0,
      )
      .to(
        arrow,
        { x: 7, y: -7, opacity: 0, duration: 0.2, ease: "power2.in" },
        0,
      )
      .to(
        clone,
        { x: 0, y: 0, opacity: 1, duration: 0.22, ease: "power2.out" },
        0.08,
      );

    leaveTl.current = gsap
      .timeline({ paused: true })
      .to(
        btn,
        {
          backgroundColor: "transparent",
          borderColor: "#d1d5db",
          duration: 0.22,
          ease: "power2.out",
        },
        0,
      )
      .to(
        arrow,
        { x: 0, y: 0, opacity: 1, duration: 0.2, ease: "power2.out" },
        0,
      )
      .to(
        clone,
        { x: -7, y: 7, opacity: 0, duration: 0.18, ease: "power2.in" },
        0,
      );

    const onEnter = () => {
      leaveTl.current.pause(0);
      enterTl.current.restart();
    };
    const onLeave = () => {
      enterTl.current.pause(0);
      leaveTl.current.restart();
    };

    row.addEventListener("mouseenter", onEnter);
    row.addEventListener("mouseleave", onLeave);
    return () => {
      row.removeEventListener("mouseenter", onEnter);
      row.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  const ArrowPath = () => (
    <path
      d="M7 17L17 7M17 7H7M17 7V17"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  );

  function SourceBadge({ src, svg }) {
    if (src) {
      return (
        <img src={src} alt="source" className="h-5 w-auto object-contain" />
      );
    }
  }

  return (
    <a
      href={article.url}
      ref={rowRef}
      className="flex items-center gap-3 sm:gap-6 md:gap-8 py-5 sm:py-6
                 border-b border-gray-100 transition-colors duration-200
                 hover:bg-gray-50/60 no-underline cursor-pointer"
    >
      {/* Desktop: logo column */}
      <div className="flex w-32 flex-shrink-0 items-center">
        <SourceBadge src={article?.src} svg={article?.svg} />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <p
          className="text-[15px] sm:text-[16px] md:text-[17px] font-medium
                      leading-[1.5] text-[#1b152b]"
        >
          {article.title}
        </p>

        {/* Mobile + Tablet: logo & date below title */}
        <div className="flex items-center gap-2 mt-2 md:hidden flex-wrap">
          <SourceBadge
            source={article.source}
            color={article.sourceColor}
            logo={article.logo}
          />
          <span className="text-gray-300">·</span>
          <span className="text-xs text-gray-400">{article.date}</span>
        </div>
      </div>

      {/* Desktop: date */}
      <span
        className="hidden md:block flex-shrink-0 text-sm text-gray-400
                       min-w-[110px] text-right"
      >
        {article.date}
      </span>

      {/* Arrow button */}
      {/* Arrow button */}
      <div
        ref={btnRef}
        className="w-9 h-9 rounded-full border border-gray-300 flex items-center
             justify-center flex-shrink-0 overflow-hidden relative"
        style={{ backgroundColor: "transparent" }}
      >
        {/* Default: arrow right — wrapped in div for GSAP ref */}
        <div
          ref={arrowRef}
          className="absolute flex items-center justify-center text-gray-700"
        >
          <BsArrowRight size={15} />
        </div>

        {/* Hover: arrow top-right (clone) */}
        <svg
          ref={cloneRef}
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          className="absolute"
          style={{ color: "#ffffff" }}
        >
          <path
            d="M7 17L17 7M17 7H7M17 7V17"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </a>
  );
}

// ── Main Section ──────────────────────────────────────────
export default function PressDetail() {
  const rowRefs = useRef(articles.map(() => ({ current: null })));

  useEffect(() => {
    const ctx = gsap.context(() => {
      rowRefs.current.forEach((ref, i) => {
        const row = ref.current;
        if (!row) return;
        gsap.fromTo(
          row,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.65,
            ease: "power3.out",
            delay: i * 0.07,
            scrollTrigger: {
              trigger: row,
              start: "top 88%",
              toggleActions: "play none none none",
            },
          },
        );
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <section className="w-full bg-white px-4 sm:px-8 md:px-16 py-10">
      <div className="max-w-[1200px] mx-auto">
        <div>
          {articles.map((article, i) => (
            <ArticleRow
              key={article.id}
              article={article}
              rowRef={rowRefs.current[i]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
